export default __webpack_public_path__ + "static/metaverse@2x-007b4117ffd8556204c7a9e1a6fea8ab.png";